var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { State, Action, Selector } from '@ngxs/store';
import { OrganizationsStateModel } from './organizations.state.model';
import { SelectOrganization, SetOrganizations, SelectCollection, GetCollectionsSuccess, GetCollections, JoinOrganization, JoinOrganizationSuccess, JoinOrganizationFail, ResetOrganizations } from './organizations.actions';
import { OrganizationsService } from '../organizations.service';
import { WidgetOptions } from 'src/app/publish/models/widget-options.model';
import { PublishService } from 'src/app/publish/publish.service';
import { SetPublishWidgetURL } from 'src/app/publish/state/publish.actions';
const initialState = {};
let OrganizationsState = class OrganizationsState {
    constructor(organizationsService, publishService) {
        this.organizationsService = organizationsService;
        this.publishService = publishService;
    }
    /**
     * Selectors
     */
    static getOrganizations(state) {
        return state.organizations;
    }
    static getOrganization(state) {
        return state.organization;
    }
    static getSelectedOrganization(state) {
        return state.selectedOrganization;
    }
    static getCollections(state) {
        return state.collections;
    }
    static getSelectedCollection(state) {
        return state.selectedCollection;
    }
    static getWidgetURL(state) {
        return state.widgetURL;
    }
    static getWidgetOptions(state) {
        return state.widgetOptions;
    }
    static getAppFeatures(state) {
        return state.appFeatures;
    }
    /**
     * Actions
     */
    selectOrganization(context, action) {
        const organization = action.organization;
        context.patchState({
            selectedOrganization: organization,
            selectedCollection: null
        });
    }
    setOrganizations(context, action) {
        const organizations = action.organizations || [];
        const organization = organizations[0];
        let widgetURL;
        let widgetOptions = null;
        let appFeatures = Object.assign({}, context.getState().appFeatures);
        // read organization widget settings
        if (organization && organization.group_attributes) {
            const attributes = organization.group_attributes;
            // set org default widget url
            const widgetURLAttribute = this.organizationsService.getOrganizationAttribute(attributes, 'widget_settings', 'widget_custom_url_path');
            if (widgetURLAttribute && widgetURLAttribute.value) {
                widgetURL = widgetURLAttribute.value;
            }
            // set org default options
            const widgetOptionsAttribute = this.organizationsService.getOrganizationAttribute(attributes, 'widget_settings', 'widget_url_params');
            if (widgetOptionsAttribute && widgetOptionsAttribute.value) {
                widgetOptions = this.publishService.extendWidgetOptions(new WidgetOptions(), widgetOptionsAttribute.value);
            }
            // set org app features
            const appFeaturesAttribute = this.organizationsService.getOrganizationAttribute(attributes, 'app_settings', 'web_app_features');
            if (appFeaturesAttribute) {
                appFeatures = Object.assign({}, appFeatures, appFeaturesAttribute.value);
            }
        }
        context.patchState({
            organization: organization,
            organizations: organizations,
            widgetURL: widgetURL,
            widgetOptions: widgetOptions,
            appFeatures: appFeatures
        });
        // set default widget
        context.dispatch(new SetPublishWidgetURL(widgetURL));
    }
    joinOrganization(context, { organization }) {
        this.organizationsService.addUserToOrganization(organization.eid)
            .subscribe(() => context.dispatch(new JoinOrganizationSuccess(organization)), (err) => context.dispatch(new JoinOrganizationFail(organization)));
    }
    getCollections(context, action) {
        this.organizationsService.getCollections(action.organizationId)
            .subscribe((collections) => {
            context.dispatch(new GetCollectionsSuccess(collections));
        });
    }
    getCollectionsSuccess(context, action) {
        context.patchState({
            collections: action.collections
        });
    }
    selectCollection(context, action) {
        const { organization, selectedOrganization } = context.getState();
        const collection = action.collection;
        context.patchState({
            // ensure organization selected
            selectedOrganization: selectedOrganization || organization,
            selectedCollection: collection
        });
    }
    resetOrganizations(context, action) {
        context.setState(initialState);
    }
};
__decorate([
    Action(SelectOrganization),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SelectOrganization]),
    __metadata("design:returntype", void 0)
], OrganizationsState.prototype, "selectOrganization", null);
__decorate([
    Action(SetOrganizations),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetOrganizations]),
    __metadata("design:returntype", void 0)
], OrganizationsState.prototype, "setOrganizations", null);
__decorate([
    Action(JoinOrganization),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, JoinOrganization]),
    __metadata("design:returntype", void 0)
], OrganizationsState.prototype, "joinOrganization", null);
__decorate([
    Action(GetCollections),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, GetCollections]),
    __metadata("design:returntype", void 0)
], OrganizationsState.prototype, "getCollections", null);
__decorate([
    Action(GetCollectionsSuccess),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, GetCollectionsSuccess]),
    __metadata("design:returntype", void 0)
], OrganizationsState.prototype, "getCollectionsSuccess", null);
__decorate([
    Action(SelectCollection),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SelectCollection]),
    __metadata("design:returntype", void 0)
], OrganizationsState.prototype, "selectCollection", null);
__decorate([
    Action(ResetOrganizations),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ResetOrganizations]),
    __metadata("design:returntype", void 0)
], OrganizationsState.prototype, "resetOrganizations", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [OrganizationsStateModel]),
    __metadata("design:returntype", void 0)
], OrganizationsState, "getOrganizations", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [OrganizationsStateModel]),
    __metadata("design:returntype", void 0)
], OrganizationsState, "getOrganization", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [OrganizationsStateModel]),
    __metadata("design:returntype", void 0)
], OrganizationsState, "getSelectedOrganization", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [OrganizationsStateModel]),
    __metadata("design:returntype", void 0)
], OrganizationsState, "getCollections", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [OrganizationsStateModel]),
    __metadata("design:returntype", void 0)
], OrganizationsState, "getSelectedCollection", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [OrganizationsStateModel]),
    __metadata("design:returntype", void 0)
], OrganizationsState, "getWidgetURL", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [OrganizationsStateModel]),
    __metadata("design:returntype", void 0)
], OrganizationsState, "getWidgetOptions", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [OrganizationsStateModel]),
    __metadata("design:returntype", void 0)
], OrganizationsState, "getAppFeatures", null);
OrganizationsState = __decorate([
    State({
        name: 'organizations',
        defaults: {}
    }),
    __metadata("design:paramtypes", [OrganizationsService,
        PublishService])
], OrganizationsState);
export { OrganizationsState };
